import type { IObjectiveActingAsAGuarantor } from './ObjectiveActingAsAGuarantor.interface';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveActingAsAGuarantor implements IObjectiveActingAsAGuarantor {
  guaranteeingLoan: YesNoOption;
  guaranteeingLoanComments: string;

  static build = (data: IObjectiveActingAsAGuarantor) => new ObjectiveActingAsAGuarantor(data);
  static blank = () => new ObjectiveActingAsAGuarantor();

  /**
   * Constructor
   * @param {IObjectiveActingAsAGuarantor} data
   */
  constructor(data?: IObjectiveActingAsAGuarantor) {
    this.guaranteeingLoan = YesNoOption.of(
      data?.guaranteeingLoan?.name || data?.guaranteeingLoan?.toString()
    );
    this.guaranteeingLoanComments = data?.guaranteeingLoanComments || '';
  }
}
